import { useEmployeeSession } from "~/stores/employeeSession.js";

export default defineNuxtRouteMiddleware(async (to) => {
  const employeeSession = useEmployeeSession();

  if (to.path.startsWith("/setup") || to.path === "/login") {
    return;
  }

  if (!employeeSession.isAuthenticated) {
    return navigateTo("/login");
  }
});
